/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedExternal from '../embed/external.defs'

const $nsid = 'app.bsky.unspecced.getAtmosphereExploreTab'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  langs: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'language' })),
  ),
  countryCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  regionCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  announcementBanner: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<AnnouncementBanner>((() => announcementBanner) as any),
  ),
  articles: /*#__PURE__*/ l.ref<ArticleList>((() => articleList) as any),
  publications: /*#__PURE__*/ l.ref<PublicationList>(
    (() => publicationList) as any,
  ),
  photos: /*#__PURE__*/ l.ref<GalleryList>((() => galleryList) as any),
  livestreams: /*#__PURE__*/ l.ref<LivestreamList>(
    (() => livestreamList) as any,
  ),
  apps: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<AppCard>((() => appCard) as any),
    { maxLength: 100 },
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get Atmosphere Explore content. Articles are recommended when algorithmic recommendations are enabled for the request, and curated otherwise; other sections are curated. Authentication is optional; authenticated requests include viewer-specific profile state. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type ArticleList = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#articleList'
  items: ArticleItem[]

  /**
   * Snowflake for this list's recommendation, use when submitting recommendation events. Omitted when the list is not algorithmically recommended.
   */
  recIdStr?: string
}

export type { ArticleList }

const articleList = /*#__PURE__*/ l.typedObject<ArticleList>(
  $nsid,
  'articleList',
  /*#__PURE__*/ l.object({
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ArticleItem>((() => articleItem) as any),
    ),
    recIdStr: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { articleList }

type PublicationList = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#publicationList'
  items: PublicationItem[]

  /**
   * Snowflake for this list's recommendation, use when submitting recommendation events. Omitted when the list is not algorithmically recommended.
   */
  recIdStr?: string
}

export type { PublicationList }

const publicationList = /*#__PURE__*/ l.typedObject<PublicationList>(
  $nsid,
  'publicationList',
  /*#__PURE__*/ l.object({
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<PublicationItem>((() => publicationItem) as any),
    ),
    recIdStr: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { publicationList }

type GalleryList = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#galleryList'
  items: GalleryItem[]

  /**
   * Snowflake for this list's recommendation, use when submitting recommendation events. Omitted when the list is not algorithmically recommended.
   */
  recIdStr?: string
}

export type { GalleryList }

const galleryList = /*#__PURE__*/ l.typedObject<GalleryList>(
  $nsid,
  'galleryList',
  /*#__PURE__*/ l.object({
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<GalleryItem>((() => galleryItem) as any),
    ),
    recIdStr: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { galleryList }

type LivestreamList = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#livestreamList'
  items: LivestreamItem[]

  /**
   * Snowflake for this list's recommendation, use when submitting recommendation events. Omitted when the list is not algorithmically recommended.
   */
  recIdStr?: string
}

export type { LivestreamList }

const livestreamList = /*#__PURE__*/ l.typedObject<LivestreamList>(
  $nsid,
  'livestreamList',
  /*#__PURE__*/ l.object({
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<LivestreamItem>((() => livestreamItem) as any),
    ),
    recIdStr: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { livestreamList }

type ArticleItem = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#articleItem'
  featured: boolean
  view: EmbedExternal.ViewArticle
}

export type { ArticleItem }

const articleItem = /*#__PURE__*/ l.typedObject<ArticleItem>(
  $nsid,
  'articleItem',
  /*#__PURE__*/ l.object({
    featured: /*#__PURE__*/ l.boolean(),
    view: /*#__PURE__*/ l.ref<EmbedExternal.ViewArticle>(
      (() => EmbedExternal.viewArticle) as any,
    ),
  }),
)

export { articleItem }

type PublicationItem = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#publicationItem'
  featured: boolean
  view: EmbedExternal.ViewArticlePublication
}

export type { PublicationItem }

const publicationItem = /*#__PURE__*/ l.typedObject<PublicationItem>(
  $nsid,
  'publicationItem',
  /*#__PURE__*/ l.object({
    featured: /*#__PURE__*/ l.boolean(),
    view: /*#__PURE__*/ l.ref<EmbedExternal.ViewArticlePublication>(
      (() => EmbedExternal.viewArticlePublication) as any,
    ),
  }),
)

export { publicationItem }

type GalleryItem = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#galleryItem'
  featured: boolean
  view: EmbedExternal.ViewGallery
}

export type { GalleryItem }

const galleryItem = /*#__PURE__*/ l.typedObject<GalleryItem>(
  $nsid,
  'galleryItem',
  /*#__PURE__*/ l.object({
    featured: /*#__PURE__*/ l.boolean(),
    view: /*#__PURE__*/ l.ref<EmbedExternal.ViewGallery>(
      (() => EmbedExternal.viewGallery) as any,
    ),
  }),
)

export { galleryItem }

type LivestreamItem = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#livestreamItem'
  featured: boolean
  view: EmbedExternal.ViewLivestream
}

export type { LivestreamItem }

const livestreamItem = /*#__PURE__*/ l.typedObject<LivestreamItem>(
  $nsid,
  'livestreamItem',
  /*#__PURE__*/ l.object({
    featured: /*#__PURE__*/ l.boolean(),
    view: /*#__PURE__*/ l.ref<EmbedExternal.ViewLivestream>(
      (() => EmbedExternal.viewLivestream) as any,
    ),
  }),
)

export { livestreamItem }

type AnnouncementBanner = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#announcementBanner'
  id?: string
  title?: string
  description?: string
  url?: l.UriString
  image?: l.UriString
  overlayColor?: string
  textColor?: string
}

export type { AnnouncementBanner }

const announcementBanner = /*#__PURE__*/ l.typedObject<AnnouncementBanner>(
  $nsid,
  'announcementBanner',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 4096 })),
    title: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    url: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri', maxLength: 4096 }),
    ),
    image: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri', maxLength: 4096 }),
    ),
    overlayColor: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    textColor: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
  }),
)

export { announcementBanner }

type AppCard = {
  $type?: 'app.bsky.unspecced.getAtmosphereExploreTab#appCard'
  id?: string
  title?: string
  description?: string
  logo?: l.UriString
  backgroundImage?: l.UriString
  overlayColor?: string
  textColor?: string
  url?: l.UriString
  category?: string
}

export type { AppCard }

const appCard = /*#__PURE__*/ l.typedObject<AppCard>(
  $nsid,
  'appCard',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 4096 })),
    title: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    logo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri', maxLength: 4096 }),
    ),
    backgroundImage: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri', maxLength: 4096 }),
    ),
    overlayColor: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    textColor: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
    url: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri', maxLength: 4096 }),
    ),
    category: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 4096 }),
    ),
  }),
)

export { appCard }
